import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SidebarService } from '../../services/sidebar/sidebar.service';
import { AuthService } from '../../../modules/access-system/services/auth/auth.service';
import {ProfileComponent} from "../profile/profile.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, ProfileComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnDestroy {
  sidebarOpen = false;
  private readonly sidebarSubscription: Subscription;

  constructor(
    private readonly sidebarService: SidebarService,
    private readonly authService: AuthService
  ) {
    this.sidebarSubscription = this.sidebarService.sidebarState$.subscribe(
      isCollapsed => {
        this.sidebarOpen = !isCollapsed;
      }
    );
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  /**
   * Verifica se o login está habilitado
   */
  get isLoginEnabled(): boolean {
    return this.authService.isLoginEnabled;
  }

  /**
   * Obtém o email do usuário logado
   */
  get userEmail(): string | null {
    return this.authService.getUserEmail();
  }

  /**
   * Realiza logout
   */
  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy() {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
  }
}
